import { createApp } from "vue";
import { ApplicationInsights } from "@microsoft/applicationinsights-web";

// import App from "../App.vue";

export default (app) => {
  // const vueApp = createApp(App);

  if (window.__env.insights_config) {
    const appInsights = new ApplicationInsights({
      config: {
        connectionString: window.__env.insights_config.connectionString,
      },
    });

    if (window.__env.insights_config.connectionString) {
      appInsights.loadAppInsights();
      appInsights.trackPageView();
    }

    // Instead of app.prototype, use globalProperties in Vue 3
    app.config.globalProperties.$appInsights = appInsights;
  }

  // Ensure the app is mounted at the end
};
